// The API base URL for this build. It comes from the per-environment manifest
// (src/config/environments.json, selected by REACT_APP_ENV — see workspace
// ADMIN_SETUP.md §1.4); REACT_APP_SERVER_URL still overrides it, which is how
// the compose stack points local dev at container hostnames.
//
// No hardcoded prod URL, no hostname sniffing, and no production fallback: an
// unknown environment resolves to the "local" entry, so a misconfigured build
// fails visibly against localhost instead of silently talking to prod.
import environment, { envName } from "./environment";
import { OVERRIDES } from "./env";

const serverUrl = OVERRIDES.apiUrl || environment.apiUrl;

if (!serverUrl) {
  // eslint-disable-next-line no-console
  console.error(
    `No API base URL for environment "${envName}" — API calls will fail`
  );
}

const constant = {
  REACT_APP_SERVER_URL: serverUrl,
};

export default constant;
